import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HeadersModule } from '@shared/core/components/headers';
import { DisclaimerModule } from '@shared/core/components/disclaimer';
import { WizzardComponentsModule } from '../../components';

import { WizzardForStepThroughMenuFlowComponent } from './wizzard-for-step-through-menu-flow.shared.component';

@NgModule({
    declarations: [
        WizzardForStepThroughMenuFlowComponent
    ],
    imports: [
        CommonModule,
        HeadersModule,
        WizzardComponentsModule,
        DisclaimerModule
    ],
    exports: [
        WizzardForStepThroughMenuFlowComponent
    ],
})
export class WizzardForStepThroughMenuFlowModule { }
